/**
 * realtime-store — Store global do modo de transporte (Story E1.5.2).
 *
 * Substitui a recomendação inicial de Zustand da spec. Usa
 * `useSyncExternalStore` (built-in React 18) — zero dep nova.
 *
 * Quem consome:
 *   - `useRealtimeNotifications` (esta story) — escreve via `setMode`
 *   - `DegradedModeBadge` (Story E1.5.3) — lê via `useTransportMode`
 *
 * Padrão singleton: módulo-level state com pub/sub. Em testes, use `reset()`
 * (exportado) para isolar entre cases.
 */
import { useSyncExternalStore } from "react";

import type { TransportMode } from "@/lib/realtime-transport";

type Listener = () => void;

let mode: TransportMode = "disconnected";
const listeners = new Set<Listener>();

export function getTransportMode(): TransportMode {
  return mode;
}

export function setTransportMode(next: TransportMode): void {
  if (mode === next) return;
  mode = next;
  for (const l of listeners) l();
}

export function subscribeTransportMode(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Hook React-friendly: re-renderiza componente quando o modo muda. */
export function useTransportMode(): TransportMode {
  return useSyncExternalStore(subscribeTransportMode, getTransportMode, getTransportMode);
}

/** Test helper — reseta state global entre cases. NÃO usar em prod. */
export function _resetTransportStoreForTests(): void {
  mode = "disconnected";
  listeners.clear();
}
